import { Languages } from '../types/languages';

export function validateLanguage(language: string): boolean {
  return Object.values(Languages).includes(language as Languages)
}